import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHandHoldingHeart } from '@fortawesome/free-solid-svg-icons';
import LazyLoad from 'react-lazyload';
import Card from './Card';

export interface ProjectCardProps {
    projectName: string;
    projectURL: string;
    tag: string;
    subname: string;
    infos: string;
    technologies: string[];
    png: string;
    webp: string;
    logo?: string;
}

const ProjectCard = (props: ProjectCardProps) => {
    const techText = props.technologies.join(' • ');
    const displayURL = props.projectURL.replace(/^https?:\/\//, '');

    return (
        <Card
            icon={
                props.logo ? (
                    <img src={props.logo} alt={props.projectName} className="company-logo" />
                ) : (
                    <FontAwesomeIcon icon={faHandHoldingHeart} className="icon" />
                )
            }
        >
            <h4 className="title">
                {props.projectName}
                <br />
                <a href={props.projectURL} target="_blank" rel="noreferrer">
                    {displayURL}
                </a>
            </h4>
            <p className="description m-0">
                <strong>{props.tag}</strong> • {props.subname}
            </p>
            <a href={props.projectURL} target="_blank" rel="noreferrer" className="project-preview">
                <LazyLoad once>
                    <picture>
                        <source srcSet={props.webp} type="image/webp" />
                        <source srcSet={props.png} type="image/png" />
                        <img src={props.png} alt={props.projectName} className="img-fluid" />
                    </picture>
                </LazyLoad>
            </a>
            <p className="description">{props.infos}</p>
            <p className="description m-0">
                <strong>Tech Stack:</strong> {techText}
            </p>
        </Card>
    );
};

export default ProjectCard;
